import "./ExchangeMessage.scss";

export default {
  root: "im-exchange-message",
  potentialBeneficiary: "im-exchange-message--potentialBeneficiary",
  establishment: "im-exchange-message--establishment",
  forEstablishment: "im-exchange-message--for-establishment",
  forPotentialBeneficiary: "im-exchange-message--for-potential-beneficiary",
  headerMeta: "im-exchange-message__header-meta",
  badge: "im-exchange-message__badge",
  title: "im-exchange-message__title",
};
